import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import PhotoGallery from "@/components/base/PhotoGallery";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";

export default function KonaseemaGallerySection() {
  const { intro: konaseemaIntro, gallery: konaseemaGallery } = useKonaseemaGuide();
  const galleryImages = konaseemaGallery.slice(1);

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                About the Region
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl leading-tight text-foreground-950 font-semibold">
              The Kerala of Andhra Pradesh
            </h2>
            <div className="mt-6 space-y-5">
              {konaseemaIntro.map((paragraph) => (
                <p key={paragraph} className="text-base text-foreground-700 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={120}>
            <PhotoGallery images={galleryImages} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}